import React from 'react';
import { useI18n } from '../context/I18nContext';
import LegalRenderer from '../components/LegalRenderer';
import { getLegal } from '../lib/legalContent';

export default function PrivacyPolicy() {
  const { lang } = useI18n();
  return <LegalRenderer content={getLegal(lang, 'privacy')} />;
}
